<template>
  <v-main fluid style="position: absolute">
    <v-card v-if="articles.length == 0" width="280" class="ml-1" @click="$emit('closeWindow')">
      <v-alert v-model="alert" dismissible color="blue darken-2" border="left" elevation="2" colored-border
        icon="mdi-triangle">
        <strong>No</strong> post as yet.
      </v-alert>
    </v-card>
    <v-row class="pt-2">
      <v-card v-if="articles.length !== 0" class="ml-6 rounded-0" color="#0069c3" :width="postPingWidth" max-width="450"
        max-height="60" dark>
        <v-carousel :continuous="false" :cycle="cycle" :show-arrows="true" hide-delimiter-background hide-delimiters class="pa-0" height="550">
          <v-carousel-item v-for="article in articles" :key="article.id">
            <PostDetails :article="article" :countryName="countryName" @trigger-refresh-posts="handleTriggerRefreshPosts" @trigger-close-window="handleCloseWindow"/>
          </v-carousel-item>
        </v-carousel>
      </v-card>
    </v-row>
    <!--
    <v-card
      v-if="showNewsPage" 
      class="mx-auto pa-3 pt-0 news-page-overlay"
      :class="{'full-screen': fullScreen}"
    >
      <v-system-bar
        color="transparent"
      >
        <v-spacer></v-spacer>

        <v-icon class="mr-3" color="yellow">mdi-circle</v-icon>
        <v-icon class="mr-3" color="green" @click="toggleFullScreen">mdi-circle</v-icon>
        <v-icon color="red" @click="toggleNewsPageOverlay">mdi-circle</v-icon>
      </v-system-bar>
        <iframe 
          :src="articleAddress"
          width="100%"
          style="height: 96%;"
          frameborder="0"
          scrolling="yes"
        >
        </iframe>
    </v-card>
    -->
  </v-main>
</template>
<script>

import PostDetails from './postDetails.vue'

const moment = require('moment')
moment().format()
export default {
  data: () => ({
    // API_URL: apiUrl,
    opacity: 1,
    maximizeImage: false,
    alert: true,
    cycle: false,
    overlay: false,
    postProfileData: [''],
    profile_image: '',
    fab: "",
    onboarding: 0,
    showCommentSection: false,
    showNewsPage: false,
    showProfilePage: false,
    dialog: false,
    imgDialog: false,
    comment: "",
    comments: [],
    // new like variables //
    liked: false,
    loading: false,
    // end of like variables //
    postLike: false,
    postReping: false,
    articleAddress: "",
    fullScreen: false,
    sheet: "",
  }),

  components: {
    // commentSection,
    // profilePage,
    // profilePost,
    // donationLink,
    //likeButton,
    PostDetails,
  },
  methods: {
    handleCloseWindow(){
      this.$emit('closeWindow')
    },
    handleTriggerRefreshPosts(){
      this.$emit('refresh-posts');
    },
    // async getProfileData() {
    //   try {
    //     // fetch profile
    //     let user = localStorage.getItem('user');
    //     user = JSON.parse(user);

    //     const authToken = 'Bearer ' + user['access'];

    //     console.log(authToken)

    //     const response = await axios.get(`${this.API_URL}users/current-user/`, {
    //       headers: {
    //         'Authorization': authToken,
    //       },
    //     })
    //     // set the data returned as profile
    //     this.postProfileData = response.data;
    //     this.profile_image = this.postProfileData?.profile.profile_image;
    //     console.log(this.postProfileData);

    //   } catch (error) {
    //     // log the error
    //     console.log(error);
    //   }
    // },
    // Post like method
    // toggleProfilePage() {
    //   this.showProfilePage = !this.showProfilePage;
    // },
    next() {
      this.onboarding =
        this.onboarding + 1 === this.length ? 0 : this.onboarding + 1
    },
    prev() {
      this.onboarding =
        this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1
    },
   
    toggleFullScreen() {
      this.fullScreen = !this.fullScreen
    }
  },
  props: {
    // postId: {
    //   type: Number,
    //   required: true,
    // },
    //post: Object,
    articles: Array,
    countryName: String,
    countryEmoji: String,
    donationLinkDialog: Boolean,
  },
  computed: {
  // Change height with different screen sizes
  postPingHeight() {
    switch (this.$vuetify.breakpoint.name) {
      case 'xs': return 190;
      case 'sm': return 69;
      case 'md': return 69;
      case 'lg': return 69;
      case 'xl': return 69;
      default: return 69; // Default value if no match
    }
  },
  postPingWidth() {
    switch (this.$vuetify.breakpoint.name) {
      case 'xs': return 365;
      case 'sm': return 380;
      case 'md': return 430;
      case 'lg': return 430;
      case 'xl': return 430;
      default: return 430; // Default value if no match
    }
  }
},

  // computed: {
  //   // Change height with different screen size
  //   postPingHeight() {
  //     switch (this.$vuetify.breakpoint.name) {
  //       case 'xs': return 190
  //       case 'sm': return 69
  //       case 'md': return 69
  //       case 'lg': return 69
  //       case 'xl': return 69
  //     }
  //   },
  //   postPingWidth() {
  //     switch (this.$vuetify.breakpoint.name) {
  //       case 'xs': return 365
  //       case 'sm': return 380
  //       case 'md': return 430
  //       case 'lg': return 430
  //       case 'xl': return 430
  //     }
  //   }
  // },
  // created() {
  //   this.getProfileData()
  // },
}
</script>

